import { render } from "./MenuCreationGroups.vue?vue&type=template&id=d34fac18"
import script from "./MenuCreationGroups.vue?vue&type=script&lang=js"
export * from "./MenuCreationGroups.vue?vue&type=script&lang=js"

import "./MenuCreationGroups.vue?vue&type=style&index=0&id=d34fac18&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__